import Box                 from '@/components/box/Box'
import { Button }          from '@/components/ui/button';
import { toaster }         from '@/components/ui/toaster';
import { Text }            from '@chakra-ui/react';
import React               from 'react';
import { useTranslation }  from 'react-i18next';
import PasswordModal       from '../modals/PasswordModal';

const PasswordBox = () => {
	const { t } = useTranslation();
	const [passwordModalIsOpen, setPasswordModalIsOpen] = React.useState(false);

	const onChangePasswordSuccess = () => {
		toaster.create({
			title: t('pages.security.passwordBox.modals.forms.messages.success'),
			type: 'success'
		})
	}

	return (
		<Box>
			<PasswordModal isOpen={passwordModalIsOpen} setIsOpen={setPasswordModalIsOpen} onChangePasswordSuccess={onChangePasswordSuccess} />
			<Text className='poppins-semibold' fontSize="16px">{t('pages.security.passwordBox.title')}</Text>
			<Button onClick={() => setPasswordModalIsOpen(true)} >{t('pages.security.passwordBox.actions.edit')}</Button>
		</Box>
	);
};

export default PasswordBox;